module.exports = __webpack_public_path__ + "static/img/4974_phase_function_Paper_PointsHejduk_Prediction.b6669c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4974_phase_function_Paper_PointsHejduk_Prediction.png
// module id = xBKV
// module chunks = 0